import React, { useMemo, useRef, useState } from 'react';

import { useRecoilValue } from 'recoil';

import adminState from 'components/admin/lib/adminState';
import Avatar from 'components/shared/Avatar/Avatar';
import Input from 'components/shared/Input/Input';
import state from 'components/state';

const CommentInput = ({ focusOnMount, onPost, loading = false, placeholder = 'Reply' }) => {
  const inputRef = useRef(null);

  const user = useRecoilValue(state.userState);
  const adminUser = useRecoilValue(adminState.current_admin);
  const permission = useRecoilValue(state.permissions);

  const [value, setValue] = useState('');

  const persistedAdminUser = useMemo(() => {
    try {
      const localStorageAdmin = localStorage.getItem('admin-state');
      return localStorageAdmin ? JSON.parse(localStorageAdmin) : null;
    } catch {
      return null;
    }
  }, []);
  const adminActor = adminUser?.user_id ? adminUser : persistedAdminUser;
  const adminActorId = adminActor?.user_id;
  const isImpersonating = Boolean(permission?.admin_id);
  const isAdminActorMatched = Number(permission?.admin_id) === Number(adminActorId);
  const actorUser = isImpersonating && isAdminActorMatched ? adminActor : user;

  const handlePost = () => {
    if (value.trim() === '' || loading) return;
    onPost(value);
    setValue('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handlePost();
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="relative">
        <Avatar
          firstName={actorUser?.f_name}
          lastName={actorUser?.l_name}
          id={permission?.admin_id || actorUser?.user_id}
          image={actorUser?.profile_photo}
          className="absolute left-3 top-1/2 z-10 !h-5 !min-h-5 !w-5 !min-w-5 -translate-y-1/2"
        />
        <Input
          forwardedRef={inputRef}
          focusOnMount={focusOnMount}
          placeholder={placeholder}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={loading}
          rightIcon="send-2-mono"
          rightIconColor="primary"
          rightIconClick={handlePost}
          inputClassName="pl-8"
        />
      </div>
    </div>
  );
};

export default CommentInput;
